import React, { useState } from 'react';
import styled from 'styled-components';

import { formatDateStringWithTimezone, formatTicketAmount, formatTicketPrize } from '../../../../utils/formatters';
import BooleanIcon from '../../../elements/booleanIcon';

import CRMApi from 'Api/CRM/CRMApi';
import LotteryTicket from 'Api/Models/LotteryTicket';
import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';
import useNumberParams from 'crm/hooks/useNumberParams';
import useOnce from 'crm/hooks/useOnce';
import { TemplateSlugs } from 'utils/TemplateSlugs';
import { getTemplateName } from 'utils/template';

const templateSlug = getTemplateName();
const imagesPath = '/images/crm/ticket-user-view/';

const Wrapper = styled.section`
    background: url('${imagesPath}${getBackgroundFile(templateSlug, 2)}') no-repeat;
    @media (min-width: 1050px) {
        padding-left: 20em;
        background: url('${imagesPath}${getBackgroundFile(templateSlug)}') no-repeat;
    }
    th {
        width: 25% !important;
    }
`;
const Lottery = styled.span`
    color: ${getLotteryColor(templateSlug)};
    font-weight: bold;
`;
const FontMedium = styled.span`
    font-size: 1.4em;
`;
const FontLarge = styled.span`
    font-size: 1.7em;
    font-weight: 500;
`;
const defaultCurrency = process.env.MIX_CURRENCY;

function TicketUserView() {
    const { id } = useNumberParams();
    const [ticket, setTicket] = useState<LotteryTicket>(new LotteryTicket({}));

    useOnce(() =>
        CRMApi.get(`lottery_ticket/${id}/user_view`).then((response) => setTicket(new LotteryTicket(response.data)))
    );

    return (
        <div className="ticket-user-view">
            <Card>
                <Wrapper>
                    <TableDetailsBody>
                        <Row label="Lottery" showIf={!!ticket.lottery_name}>
                            <Lottery>{ticket.lottery_name}</Lottery>
                        </Row>
                        <Row label="Status" showIf={!!ticket.status}>
                            <span className="text-capitalize">{ticket.status}</span>
                        </Row>
                        <Row label="Paid out" showIf={ticket.id > 0}>
                            <BooleanIcon value={ticket.paid_out} /> {ticket.paid_out ? 'Yes' : 'No'}
                        </Row>
                        <Row label="Amount" showIf={!!ticket.system_sell_amount_gross}>
                            <FontMedium>{formatTicketAmount(ticket.system_sell_amount_gross, defaultCurrency)}</FontMedium>
                        </Row>
                        <Row label="Draw date">{formatDateStringWithTimezone(ticket.draw_date)}</Row>
                        <Row label="Prize" showIf={!!ticket.prizeGross}>
                            <FontLarge>{formatTicketPrize(ticket.prizeGross)}</FontLarge>
                        </Row>
                        <Row label="Purchase date">{formatDateStringWithTimezone(ticket.created_at)}</Row>
                    </TableDetailsBody>
                </Wrapper>
            </Card>
        </div>
    );
}

function getBackgroundFile(slug: TemplateSlugs, fileNumber: number | null = null): string {
    const suffix = typeof fileNumber === 'number' ? fileNumber.toString() : '';

    switch (slug) {
        case TemplateSlugs.lottopark:
            return `winner-lottopark${suffix}.png`;
        case TemplateSlugs.nigeria:
            return `winner-nigeria${suffix}.png`;
        case TemplateSlugs.zambia:
        default:
            return `winner-zambia${suffix}.png`;
    }
}

function getLotteryColor(slug: TemplateSlugs): string {
    switch (slug) {
        case TemplateSlugs.lottopark:
            return '#17796f';
        case TemplateSlugs.nigeria:
            return '#14b69f';
        case TemplateSlugs.zambia:
        default:
            return '#1E964A';
    }
}

export default TicketUserView;
